import React, { useState } from 'react';
import axios from 'axios';
import API_URL from '../api/baseURL';

export default function MarkInvoicePaidButton({ invoiceId, token, onMarked }) {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const markPaid = async () => {
    setLoading(true);
    try {
      await axios.patch(
       `${API_URL}/workshop-invoices/invoice/${invoiceId}/mark-paid`,
       {}, // empty body
       {
        headers: { Authorization: `Bearer ${token}` }
       }
      );

      setMsg('Réglée');
      if (onMarked) onMarked();
    } catch {
      setMsg('Erreur');
    }
    setLoading(false);
  };

  return (
    <button
      onClick={markPaid}
      disabled={loading}
      className="h-[26px] px-2.5 rounded-[7px] text-[11px] font-medium whitespace-nowrap transition-colors
                 border border-[#2B3A31] bg-[#121714] text-[#74A98D] hover:border-[#74A98D]/50
                 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? 'Traitement…' : msg || 'Marquer réglée'}
    </button>
  );
}
